import styled from "styled-components";
import LeftArrow from "@assets/svg/LeftArrow.svg?react";
import CheckFeat from "@assets/svg/CheckFeat.svg?react";
import ArrowRight from "@assets/svg/RightArrow.svg?react";
import { Swiper } from "swiper/react";

// Common Interfaces
export interface StyleProps {
  $isActive: boolean;
  $isRTL?: boolean;
}

export interface BreakpointProps {
  $isPhone?: boolean;
}

// =============== Toggle Styles ===============
export const ToggleContainer = styled.div<BreakpointProps>`
  margin-bottom: ${({ $isPhone }) => ($isPhone ? "24px" : "0")};
`;
export const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const ToggleWrapper = styled.span<BreakpointProps>`
  display: flex;
  align-items: center;
  gap: 4px;
  justify-content: center;
  width: 300px;
  height: 34px;
  background: #f3f3f3;
  border-radius: 8px;
  padding-inline: 4px;
`;

export const ToggleOption = styled.span<StyleProps>`
  cursor: pointer;
  display: flex;
  ${({ $isActive }) => $isActive && "flex: 1"};
  align-items: center;
  justify-content: center;
  ${({ $isActive }) => $isActive && "gap: 10px"};
  width: 68px;
  height: 26px;
  padding: 8px 16px;
  background: ${({ $isActive }) => ($isActive ? "#FFFFFF" : "#F3F3F3")};
  color: ${({ $isActive }) => ($isActive ? "#5B3FFF" : "inherit")};
  font-size: 14px;
  border-radius: 4px;
  box-shadow:
    0px 2px 3px 0px #0000000a,
    0px 24px 68px 0px #2f30370d,
    0px 4px 6px 0px #222a350a,
    0px 1px 1px 0px #0000000d;
  font-weight: ${({ $isActive }) => ($isActive ? 700 : 400)};
`;

export const DiscountBadge = styled.span`
  font-weight: 400;
  font-size: 18px;
  color: #16ae26;
`;

// =============== Card Styles ===============
export const CardContainer = styled.div<BreakpointProps>`
  margin-inline: ${({ $isPhone }) => ($isPhone ? "1px" : "0")};
  width: ${({ $isPhone }) => ($isPhone ? "95%" : "290px")};
  min-height: 460px;
  border-radius: 12px;
  padding: 8px;
  margin-top: 44px;
  box-shadow:
    0px 9.08px 21.18px -3.03px #eaeafd33,
    0px 3.03px 9.08px 0px #eaeafd14,
    0px 0px 0px 0.61px #eaeafd;
`;

export const PriceSection = styled.section<BreakpointProps>`
  width: ${({ $isPhone }) => ($isPhone ? "85%" : "100%")};
  height: 127px;
  border-radius: 12px;
  padding: 24px;
  display: flex;
  flex-direction: column;
  background: #261b6a;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #f2f2f2f2;
  cursor: pointer;
`;

export const PackageName = styled.span`
  width: 100%;
  font-weight: 700;
  font-size: 14px;
  color: #ffffff;
`;

export const PriceContainer = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  gap: 12px;
  font-weight: 700;
  font-size: 27px;
  color: #ffffff;
`;

export const OriginalPrice = styled.span`
  font-weight: 400;
  font-size: 17px;
  color: #ffffff;
  text-decoration: line-through;
  opacity: 0.7;
`;

export const BillingInfo = styled.span`
  width: 100%;
  font-weight: 400;
  font-size: 14px;
  color: #ffffff;
  opacity: 0.7;
`;

export const Divider = styled.span`
  border-bottom: 1px solid #f2f2f2;
  margin-block: 20px;
  width: 100%;
  display: block;
`;

export const SubscribeButton = styled.div`
  cursor: pointer;
  height: 41px;
  background: #5b3fff;
  border-radius: 99999px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-inline: 20px;
  color: #ffffff;
`;

export const ButtonText = styled.span`
  font-weight: 700;
  font-size: 13px;
  color: #ffffff;
`;

export const StyledLeftArrow = styled(LeftArrow)`
  width: 12px;
  height: 16px;
  fill: #62606f;
`;
export const StyledRightArrow = styled(LeftArrow)`
  width: 12px;
  height: 16px;
  fill: #62606f;
  rotate: 180deg;
`;

export const FeaturesList = styled.span`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const FeatureItem = styled.span`
  font-weight: 300;
  font-size: 13px;
  gap: 5px;
  display: flex;
  align-items: center;
`;

export const StyledCheckFeat = styled(CheckFeat)`
  width: 11px;
  height: 9px;
  fill: #5b3fff;
`;

export const PlaceholderCard = styled.div<BreakpointProps>`
  background: #fff;
  border-radius: 12px;
  padding: 20px;
  width: ${({ $isPhone }) => ($isPhone ? "90%" : "290px")};
  min-height: 460px;
  box-shadow:
    0px 9.08px 21.18px -3.03px #eaeafd33,
    0px 3.03px 9.08px 0px #eaeafd14,
    0px 0px 0px 0.61px #eaeafd;
  display: flex;
  flex-direction: column;
  gap: 16px;
  justify-content: center;
  margin-top: 44px;
`;

// =============== Page Layout Styles ===============
export const PageContainer = styled.div<BreakpointProps>`
  position: relative;
  background: #fafafb;
  margin-inline: ${({ $isPhone }) => ($isPhone ? "16px" : "185px")};
  margin-block: ${({ $isPhone }) => ($isPhone ? "24px" : "82px")};
`;
export const Loader = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 300px;
  width: 100%;
`;

export const ContentContainer = styled.div<BreakpointProps>`
  min-height: ${({ $isPhone }) => ($isPhone ? "auto" : "750px")};
  background: #ffffff;
  border-radius: 16px;
  border: 1px solid #efeff1;
  padding: ${({ $isPhone }) => ($isPhone ? "20px" : "0")};
`;

export const BackButton = styled.span<BreakpointProps>`
  display: flex;
  align-items: center;
  justify-content: start;
  gap: 12px;
  width: 100%;
  margin-top: ${({ $isPhone }) => ($isPhone ? "0" : "40px")};
  margin-inline: ${({ $isPhone }) => ($isPhone ? "0" : "80px")};
  margin-bottom: ${({ $isPhone }) => ($isPhone ? "24px" : "0")};
`;

export const StyledArrowRight = styled(ArrowRight)`
  width: 16px;
  height: 16px;
  fill: #62606f;
`;
export const StyledArrowLeft = styled(ArrowRight)`
  width: 16px;
  height: 16px;
  transform: rotate(180deg);
`;

export const BackButtonText = styled.span<BreakpointProps>`
  font-size: ${({ $isPhone }) => ($isPhone ? "16px" : "17px")};
  font-weight: 400;
  color: #62606f;
`;

export const TitleSection = styled.span<BreakpointProps>`
  width: 100%;
  margin-top: ${({ $isPhone }) => ($isPhone ? "0" : "40px")};
  font-size: ${({ $isPhone }) => ($isPhone ? "20px" : "22px")};
  font-weight: 700;
  color: #141316;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: ${({ $isPhone }) => ($isPhone ? "24px" : "0")};
  text-align: center;
  padding-inline: ${({ $isPhone }) => ($isPhone ? "16px" : "0")};
`;

export const MobileCardsContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-bottom: 20px;
`;

export const DesktopCardsContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 24px;
  flex-direction: row;
  padding-bottom: 0;
`;

export const StyledSwiper = styled(Swiper)`
  position: relative;
  width: 100%;
  padding-bottom: 40px; /* space for pagination */

  .swiper-pagination {
    bottom: 0px;
    text-align: center;
  }

  .swiper-pagination-bullet {
    background: #ccc;
    opacity: 1;
  }

  .swiper-pagination-bullet-active {
    background: #000;
  }
`;
